import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'developmentSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <polygon points="83.3,38.4 19.5,137.2 83.3,229.1 168.4,229.1 89.4,38.4 	" />
      <polygon points="208.7,38.4 124.5,38.4 204.2,229.1 208.7,229.1 268.5,137.2 	" />
    </g>
  </svg>
);

export default SVG;
